export default __webpack_public_path__ + "static/media/alpi-training-logo.3b0ee4db.svg";